import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import {
  BooleanInput,
  DateField,
  Edit,
  FormDataConsumer,
  Labeled,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  TimeInput,
  maxLength,
  required
} from 'react-admin';
import Permission from '../../components/Permission';
import { RichTextInputCustom } from '../../components/RichTextInputCustom';
import { PERMISSIONS } from '../../constants';

const richTextSx = {
  marginTop: '16px',
  width: 'auto',
  '& .ql-editor': {
    minHeight: 200
  }
};

const charCounterSx = {
  right: '1%',
  width: 'auto',
  height: '100%',
  fontSize: 12,
  opacity: .75,
  fontFamily: 'Helvetica',
  textAlign: 'end' as const,
};

const timetzRegex = /^\d{2}:\d{2}:\d{2}\.\d{3}\+\d{2}$/;

const editMarketingCampaigns: React.FC = props => {
  const MAX_LENGTH_PUSH = 130;

  return (
    <Permission permission={PERMISSIONS.MARKETING_CAMPAIGNS}>
      <Edit {...props} title="Editar campanha">
        <SimpleForm>
          <TextInput source="title" label="Título" sx={{ minWidth: 400 }} />
          <ReferenceInput source="marketingCampaignId" reference="chains/chainId/marketing-campaigns" label="Campanha">
            <SelectInput
              label="Campanha"
              source="marketingCampaignId"
              optionText="label"
              validate={required()}
              sx={{ minWidth: 400 }}
            />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData }) =>
              <Box sx={{ marginBottom: 2 }}>
                <Labeled label="Início da campanha">
                  <DateField variant="body1" source="startDate" sx={{ marginRight: 12 }} locales="pt-BR" />
                </Labeled>
                <Labeled label="Fim da campanha">
                  {formData.alwaysActive
                    ? <Typography variant="body1">Sempre ativa</Typography>
                    : <DateField source="endDate" variant="body1" locales="pt-BR" />}
                </Labeled>
              </Box>}
          </FormDataConsumer>
          <TimeInput
            label="Horário de Envio"
            source="time"
            format={(v) => {
              if (timetzRegex.test(v)) {
                return moment(v, "HH:mm:ss.SSSZ").format("HH:mm");

              } else if (v instanceof Date) {
                return moment(v).format("HH:mm");
              }
              return null;
            }}
            variant="filled"
            sx={{ width: 160, contain: 'content' }}
            required
          />
          <Box sx={richTextSx}>
            <Labeled label="Descrição: ">
              <RichTextInputCustom
                source="body"
                label="Essa mensagem pode conter formatações e será exibida no aplicativo, na tela de notificações. Ela NÃO será enviada na notificação PUSH"
                validate={required()}
                fieldType="marketing_campaign_body"
              />
            </Labeled>
          </Box>
          <Labeled label="Enviar via: ">
            <>
              {/* <BooleanInput source="sms" label="SMS" /> */}
              <BooleanInput source="pushNotification" label="Notificação no aplicativo" />
            </>
          </Labeled>
          <FormDataConsumer>
            {({ formData }) => formData.pushNotification &&
              <Labeled label="Esta mensagem será enviada na notificação Push:" sx={{ width: '70%' }}>
                <>
                  <TextInput
                    style={{ width: '100%' }}
                    source="pushMessage"
                    label="Mensagem Push"
                    validate={[required(), maxLength(MAX_LENGTH_PUSH)]}
                    inputProps={{ autoComplete: 'off' }}
                    helperText={false}
                  />
                  <Box component="span" sx={charCounterSx}>
                    {formData.pushMessage?.length || 0}/{MAX_LENGTH_PUSH}
                  </Box>
                </>
              </Labeled>
            }
          </FormDataConsumer>
          <BooleanInput source="endCampaign" label="Encerrar campanha" sx={{ marginTop: 4 }} />
          <Typography variant="body1" style={{ width: '100%', marginTop: 16 }}>
            * Quaisquer alterações realizadas estarão valendo apenas a partir do dia seguinte.
          </Typography>
        </SimpleForm>
      </Edit>
    </Permission>
  )
}

export default editMarketingCampaigns;
